import { PlanItem as PlanItemView } from "@modules/entities/PlanItemList/PlanItem";
import { Direction } from "@dto/Direction";
import { PlanItem } from "@dto/PlanItem";
import { ItemDirection } from "@domain/ItemDirection";
import { Fragment, FunctionComponent } from "react";
import { PlanItemTravelIndicator } from "@modules/entities/PlanItemList/PlanItemTravelIndicator";

interface EntityItemListProps {
  planItems: PlanItem[];
  /**
   * Directions data for the parent Tour.
   * Google legacy Directions API based.
   */
  directions?: Direction | null;
  /**
   * Directions data for the parent Plan.
   * Google Routes API based.
   */
  itemDirections?: ItemDirection[] | null | undefined;
}

const EntityItemList: FunctionComponent<EntityItemListProps> = ({
  planItems,
  directions,
}) => {
  const legs = directions?.routes[0]?.legs;

  return (
    <div className="plan-item-list-component">
      {planItems.map((planItem, index) => (
        <Fragment key={planItem.id}>
          <PlanItemView planItem={planItem} ordinal={index + 1} />
          <PlanItemTravelIndicator leg={legs ? legs[index] : undefined} />
        </Fragment>
      ))}
    </div>
  );
};

export { EntityItemList };
